import { i18n } from '@/locales';
import { vuexEventPathGenerator } from '@/utils';
import { parse } from 'date-fns';
import dateFormatType from '@/constants/dateFormatType';
const dateFormat = dateFormatType.DATE;
const lc = 'views.operation_setting_history.';
const getterType = {
    getterSelectedHub: 'getterSelectedHub',
    getterBetweenDate: 'getterBetweenDate',
    getterBetweenDateToTimeStamp: 'getterBetweenDateToTimeStamp',
    getterPaginationData: 'getterPaginationData',
    getterPageSize: 'getterPageSize',
    getterHubOptionList: 'getterHubOptionList',
    getterStoreOptionList: 'getterStoreOptionList',
    getterOperationSettingHistoryList: 'getterOperationSettingHistoryList',
};
export const operationSettingHistoryGetterType = vuexEventPathGenerator(getterType, 'operationSettingHistory');
const getter = {
    [getterType.getterSelectedHub]: (state) => state.selectedHub,
    [getterType.getterBetweenDate]: ({ filterOption }) => filterOption.betweenDate,
    /**
     * betweenDate를 timestamp로 변경
     * @param {Object} state
     * @returns {Array}
     */
    [getterType.getterBetweenDateToTimeStamp]: ({ filterOption }) => {
        const dateObject = new Date();
        const [date1, date2,] = filterOption.betweenDate;
        if (!date1 || !date2) {
            return [];
        }
        const [d1, d2,] = [
            date1,
            date2,
        ].map((it) => parse(it, dateFormat, dateObject));
        return [
            d1.setHours(0, 0, 0, 0),
            d2.setHours(23, 59, 59, 999),
        ];
    },
    [getterType.getterPaginationData]: ({ paginationData }) => {
        const { pageNumber, pages } = paginationData;
        return {
            pageNumber,
            pages,
        };
    },
    [getterType.getterPageSize]: ({ filterOption }) => filterOption.pageSize,
    [getterType.getterHubOptionList]: (data) => data.hubList.map((hub) => ({
        name: hub.name,
        value: hub.code,
    })),
    [getterType.getterStoreOptionList]: (data) => {
        const list = data.storeList.map((store) => ({
            name: store.name,
            value: store.code,
        }));
        list.unshift({
            name: i18n.t(`${lc}setting_target.all_stores_belonging_to_hub`),
            value: 'ALL',
        });
        return list;
    },
    [getterType.getterOperationSettingHistoryList]: ({ list }) => list ?? [],
};
export default getter;
